<template>
    <div class="indexModule adImg1" :data="moduleData.Guid">
        <router-link :to="moduleData.Link">
            <img :src="moduleData.Img" :style="{height:adHeight+'px'}" />
        </router-link>
    </div>
</template>

<script>
export default {
  name:'XR-mobile-adImg1',
  data() {
    return {
      adHeight: document.documentElement.clientWidth * (200/750)
    }
  },
  props:{
      guid:'',
      configData:{}
  },
  computed:{
      moduleData:function(){
        for(var i=0; i < this.configData.AdImgs.length;i++){
            var moduleItem = this.configData.AdImgs[i];
            if(this.guid == moduleItem.Guid){
                return moduleItem;
            }
        }
        return {}
    },
  }
}
</script>

<style>
    .indexModule.adImg1 {
        width:100%;
        overflow: hidden;
        padding: 10px 0;
    }
    .indexModule.adImg1 img{
        width:100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/index/mobile/adImg1/adImg1.vue